import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddProjectMaterialResourceNotificationState = createStateReducer(
  initialState,
  {
    [events.addProjectMaterialResourceSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectMaterialResource",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addProjectMaterialResourceFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectMaterialResource",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddProjectMaterialResourceNotificationState };
